import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/Home.vue')
    },
    // {
    //   path: '/RegistroB2Badmin',
    //   name: 'admin',
    //   component: () => import('./components/RegistroB2Badmin.vue')
    // },
    {
      path: '/Registroclientesadmin',
      name: 'clientesadmin',
      component: () => import('./components/RegistroClientesAdmin.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
});

export default router;
